import { clone } from "lodash";

const values = {
  renterState: "",
};

const samplePolicyInitialFormValues = () => clone(values);

export default samplePolicyInitialFormValues;
